function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  cx: 9.576,
  cy: 9.576,
  r: 8.306
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.576 19.165a9.576 9.576 0 119.577-9.577 9.588 9.588 0 01-9.577 9.577zm0-17.883a8.306 8.306 0 100 16.612 8.306 8.306 0 000-16.612z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.824,
  y: 6.376,
  width: 1.506,
  height: 8.012,
  rx: 0.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.824,
  y: 4.035,
  width: 1.506,
  height: 1.506,
  rx: 0.64
}));

function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgInfo;